<ng-container [formGroup]="stepForm">

  <mat-form-field appearance="outline" [hideRequiredMarker]="true">
    <mat-label>Kod weryfikacyjny</mat-label>
    <input
      matInput
      type="text"
      inputmode="numeric"
      placeholder="XXX-XXX"
      (keydown.enter)="onSubmit()"
      [formControl]="code"
      (input)="errors = []"
      mask="000-000"
      pattern="\d{6}"
      appGtmFormEvent
      [eventField]="'verificationCode'"
      [eventForm]="formName"
    />

    <mat-error
      *ngIf="
            code.invalid &&
            (code.dirty || !code.untouched)">
      <span *ngIf="code.errors.required">Wpisz kod weryfikacyjny</span>
    </mat-error>
    <mat-error *ngFor="let error of errors" class="error-message status-error">
      <span>{{ errorMessages[error] }}</span>
    </mat-error>
  </mat-form-field>

  <div class="actions">
    <app-new-loader-button
      (buttonClick)="onSubmit()"
      [disabled]="loading || ( submitted && !stepForm.valid)"
      [loading]="loading"
      class="auth-button"
      id="register-button"
      [customType]="LoaderButtonType.RAISED"
      color="accent">
      Dalej
    </app-new-loader-button>
  </div>
  <footer fxLayout="row" class="footer">
    <p>
      Nie otrzymałeś SMS-a?
      <button type="button" *ngIf="!sentCode" (click)="onSendCodeClick()" class="inline-button">Wyślij kod ponownie
      </button>
      <span *ngIf="sentCode" class="inline-button">Wysłano kod</span>
    </p>
  </footer>
</ng-container>
